export default "__VITE_ASSET__kXMEE6QZ__"